import { render, staticRenderFns } from "./ListCrew.vue?vue&type=template&id=2b8b7cc3&"
import script from "./ListCrew.vue?vue&type=script&lang=js&"
export * from "./ListCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports